import { useMemo } from "react"
import { useSearchParams } from "react-router-dom"

export function useProductPageSearchParams({
  productType
}: {
  productType: string
}) {
  const [searchParams] = useSearchParams()

  const variantKey = useMemo(
    () => searchParams.get("variantKey") || productType,
    [searchParams, productType]
  )

  const configurationKey = useMemo(
    () => searchParams.get("configurationKey"),
    [searchParams]
  )

  const dimensioningKey = useMemo(
    () => searchParams.get("dimensioningKey"),
    [searchParams]
  )
  return {
    variantKey,
    configurationKey,
    dimensioningKey
  }
}
